export default __webpack_public_path__ + "static/media/imgCardOffer2.1573c9dd.jpg";